import React from "react";

export default function ShowImage({imgurl}) {
    if(imgurl === undefined || imgurl === null) {
        return null;
    }
    return (
        <div style={{width: '300px', height: '200px', overflow: 'hidden'}}>
            <img src={imgurl} alt="Image" 
            className='w-100 h-100 object-contain rounded-3'
            />
        </div>
    );
}